 import firebase from 'firebase'
 import firestore from 'firebase/firestore'
 
 // Your web app's Firebase configuration
 var firebaseConfig = {
    apiKey: "AIzaSyAz11k0Navgv1Pp24lf_6SrLetgF9HXMpI",
    authDomain: "geo-meow.firebaseapp.com",
    databaseURL: "https://geo-meow.firebaseio.com",
    projectId: "geo-meow",
    storageBucket: "",
    messagingSenderId: "497373616150",
    appId: "1:497373616150:web:bc2894b049173a88"
  };
  // Initialize Firebase
 const firebaseApp = firebase.initializeApp(firebaseConfig);

 export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/firebase/init.js